var detectBrowser = require('./lib/detectBrowser');

var agent;

if (typeof navigator !== 'undefined' && navigator) {
  agent = navigator.userAgent;
}

module.exports = detectBrowser(agent);



//////////////////
// WEBPACK FOOTER
// ./~/detect-browser/browser.js
// module id = 962
// module chunks = 1